module.exports = __webpack_public_path__ + "img/Download.6955b5d4.png";